import { render, staticRenderFns } from "./EditedBadge.vue?vue&type=template&id=0ad0c693&"
import script from "./EditedBadge.vue?vue&type=script&lang=js&"
export * from "./EditedBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports